var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEsChevronDownSmBlack({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.70715 6.48824C4.97587 6.22986 5.40318 6.23824 5.66156 6.50696L9 10.0509L12.3384 6.50696C12.5968 6.23824 13.0241 6.22986 13.2928 6.48824C13.5616 6.74663 13.5699 7.17393 13.3116 7.44265L9.48656 11.4927C9.3593 11.625 9.18361 11.6998 9 11.6998C8.81639 11.6998 8.6407 11.625 8.51344 11.4927L4.68844 7.44265C4.43005 7.17393 4.43843 6.74663 4.70715 6.48824Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEsChevronDownSmBlack);
export default __webpack_public_path__ + "static/media/es_chevron_down_sm_black.725cdfb0c5236e0b1f097de488307a5a.svg";
export { ForwardRef as ReactComponent };